<template>
<d2-container>
    <h2>车型管理</h2>

    <el-form ref="elForm" size="medium" label-width="100px">
        <el-row>
            <el-form-item label="车型" prop="dd">
                <el-input v-model="listQuery.carModel" placeholder="车型搜索" clearable :style="{width: '763px'}"></el-input>
            </el-form-item>
        </el-row>
        <el-form-item size="large">
            <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
        </el-form-item>
    </el-form>

    <!--添加-->
    <el-button size="small" class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">添加</el-button>

    <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">

        <el-table-column align="center" label="id" width="65">
            <template slot-scope="scope">
                <span>{{scope.row.id}}</span>
            </template>
        </el-table-column>
        <el-table-column  align="center" label="车型名称">
            <template slot-scope="scope">
                <span>{{scope.row.carModel}}</span>
            </template>
        </el-table-column>
        <el-table-column width="200px" align="center" label="车型编码">
            <template slot-scope="scope">
                <span>{{scope.row.carModelCode}}</span>
            </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="150"> <template slot-scope="scope">
                <el-button size="small" type="success" @click="handleUpdate(scope.row)">编辑
                </el-button>
                <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除
                </el-button>
            </template> </el-table-column>
    </el-table>
    <template slot="footer">
        <div v-show="!listLoading" class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
        </div>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="车型名称" prop="carModel">
                <el-input v-model="form.carModel" placeholder="请输入车型名称"></el-input>
            </el-form-item>
            <el-form-item label="车型编码" prop="carModelCode">
                <el-input v-model="form.carModelCode" placeholder="请输入车型编码"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel('form')" size="small">取 消</el-button>
            <el-button v-if="dialogStatus=='create'" size="small" type="primary" @click="create('form')">确 定</el-button>
            <el-button v-else type="primary" size="small" @click="update('form')">确 定</el-button>
        </div>
    </el-dialog> 
</d2-container>
</template>

<script>
import {
    page,
    addObj,
    getObj,
    delObj,
    putObj
} from '@/api/admin/sysCarModel/index';
import {
    mapGetters
} from 'vuex';
export default {
    name: 'sysCarModel',
    data() {
        return {
            form: {
                carModel: undefined,
                carModelCode: undefined
            },
            rules: {
                carModel: [{
                    required: true,
                    message: '请输入车型名称',
                    trigger: 'blur'
                }],
                carModelCode: [{
                    required: true,
                    message: '请输入车型编码',
                    trigger: 'blur'
                }]
            },
            list: null,
            total: null,
            listLoading: true,
            listQuery: {
                page: 1,
                limit: 20,
                carModel: undefined
            },
            dialogFormVisible: false,
            dialogStatus: '',
            textMap: {
                update: '编辑',
                create: '创建'
            },
            tableKey: 0
        }
    },
    created() {
        this.getList();
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
        getList() {
            this.listLoading = true;
            page(this.listQuery).then(response => {
                this.list = response.rows;
                this.total = response.total;
                this.listLoading = false;
            })
        },
        handleFilter() {
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleCreate() {
            this.resetTemp();
            this.dialogStatus = 'create';
            this.dialogFormVisible = true;
        },
        handleUpdate(row) {
            getObj(row.id)
                .then(response => {
                    this.form = response;
                    this.dialogFormVisible = true;
                    this.dialogStatus = 'update';
                });
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    delObj(row.id)
                        .then(() => {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success',
                                duration: 2000
                            });
                            const index = this.list.indexOf(row);
                            this.list.splice(index, 1);
                        });
                });
        },
        create(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    addObj(this.form)
                        .then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        })
                } else {
                    return false;
                }
            });
        },
        cancel(formName) {
            this.dialogFormVisible = false;
            const set = this.$refs;
            set[formName].resetFields();
        },
        update(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    this.dialogFormVisible = false;
                    this.form.password = undefined;
                    putObj(this.form.id, this.form).then(() => {
                        this.dialogFormVisible = false;
                        this.getList();
                        this.$notify({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        resetTemp() {
            this.form = {
                username: undefined,
                name: undefined,
                sex: '男',
                password: undefined,
                description: undefined
            };
        },
        resetForm() {
            this.listQuery = {
                page: 1,
                limit: 20,
                carModel: undefined
            };
        }
    }
}
</script>
